import React from 'react';
import {Button, Heading, Text} from "../elements";

export const ServicesBlockElement = (props) => {

    const style = {
        backgroundImage: `url( ${ props.image })` ,
    };

    const background = {
        backgroundColor: `${ props.blockBackgroundColor }`,
        color: `${ props.blockTextColor }`
    }
    return(
        <div className="kiwi-service-block">

            {props.image &&
            <div className="kiwi-service-block__image" style={style}> </div>
            }

            <div className="kiwi-service-block__copy" style={background}>

                {props.heading &&
                <Heading content={props.heading} size="h3"/>}

                {props.text &&
                <Text content={props.text}/>}

                {props.button &&
                <Button label={props.button.label} link={props.button.link} color={props.button.color} textColor={props.button.textColor}/>}

            </div>

        </div>
    );
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/ServicesBlockElement.js